// Generated by scripts/optimize-images.py. Original photos are not bundled.
import studioElectricGuitar640 from '../assets/images/studio-electric-guitar-640.webp';
import studioElectricGuitar1280 from '../assets/images/studio-electric-guitar-1280.webp';
import studioElectricGuitar1920 from '../assets/images/studio-electric-guitar-1920.webp';
import studioElectricGuitar2560 from '../assets/images/studio-electric-guitar-2560.webp';
import studioAcousticGuitar640 from '../assets/images/studio-acoustic-guitar-640.webp';
import studioAcousticGuitar1280 from '../assets/images/studio-acoustic-guitar-1280.webp';
import studioAcousticGuitar1920 from '../assets/images/studio-acoustic-guitar-1920.webp';
import cityBeigeCoat640 from '../assets/images/city-beige-coat-640.webp';
import cityBeigeCoat1280 from '../assets/images/city-beige-coat-1280.webp';
import cityBeigeCoat1920 from '../assets/images/city-beige-coat-1920.webp';
import tomorrowStoneColumns640 from '../assets/images/tomorrow-stone-columns-640.webp';
import tomorrowStoneColumns1280 from '../assets/images/tomorrow-stone-columns-1280.webp';
import tomorrowStoneColumns1920 from '../assets/images/tomorrow-stone-columns-1920.webp';
import tomorrowStationBench640 from '../assets/images/tomorrow-station-bench-640.webp';
import tomorrowStationBench1280 from '../assets/images/tomorrow-station-bench-1280.webp';
import tomorrowStationBench1920 from '../assets/images/tomorrow-station-bench-1920.webp';
import tomorrowStationStairs640 from '../assets/images/tomorrow-station-stairs-640.webp';
import tomorrowStationStairs1280 from '../assets/images/tomorrow-station-stairs-1280.webp';
import tomorrowStationStairs1920 from '../assets/images/tomorrow-station-stairs-1920.webp';
import tomorrowCityStreet640 from '../assets/images/tomorrow-city-street-640.webp';
import tomorrowCityStreet1280 from '../assets/images/tomorrow-city-street-1280.webp';
import tomorrowCityStreet1920 from '../assets/images/tomorrow-city-street-1920.webp';
import bandLogo320 from '../assets/images/band-logo-320.webp';
import bandLogo640 from '../assets/images/band-logo-640.webp';
import bandLogo1280 from '../assets/images/band-logo-1280.webp';

const studioElectricGuitar = {
  src: studioElectricGuitar1280,
  srcSet: `${studioElectricGuitar640} 640w, ${studioElectricGuitar1280} 1280w, ${studioElectricGuitar1920} 1920w, ${studioElectricGuitar2560} 2560w`,
  width: 2560,
  height: 1707,
  alt: 'Adel Gomez with an electric guitar under red and blue studio lighting'
};

const studioAcousticGuitar = {
  src: studioAcousticGuitar1280,
  srcSet: `${studioAcousticGuitar640} 640w, ${studioAcousticGuitar1280} 1280w, ${studioAcousticGuitar1920} 1920w`,
  width: 1920,
  height: 2880,
  alt: 'Adel Gomez singing with an acoustic guitar against an orange backdrop'
};

const cityBeigeCoat = {
  src: cityBeigeCoat1280,
  srcSet: `${cityBeigeCoat640} 640w, ${cityBeigeCoat1280} 1280w, ${cityBeigeCoat1920} 1920w`,
  width: 1920,
  height: 1280,
  alt: 'Adel Gomez wearing a beige coat beside a stone wall in the city'
};

const tomorrowStoneColumns = {
  src: tomorrowStoneColumns1280,
  srcSet: `${tomorrowStoneColumns640} 640w, ${tomorrowStoneColumns1280} 1280w, ${tomorrowStoneColumns1920} 1920w`,
  width: 1920,
  height: 1280,
  alt: 'Adel Gomez holding flowers beside stone columns for As Soon as Tomorrow'
};

const tomorrowStationBench = {
  src: tomorrowStationBench1280,
  srcSet: `${tomorrowStationBench640} 640w, ${tomorrowStationBench1280} 1280w, ${tomorrowStationBench1920} 1920w`,
  width: 1920,
  height: 1280,
  alt: 'Adel Gomez seated on a station bench with flowers for As Soon as Tomorrow'
};

const tomorrowStationStairs = {
  src: tomorrowStationStairs1280,
  srcSet: `${tomorrowStationStairs640} 640w, ${tomorrowStationStairs1280} 1280w, ${tomorrowStationStairs1920} 1920w`,
  width: 1920,
  height: 2880,
  alt: 'Adel Gomez on a station staircase holding flowers for As Soon as Tomorrow'
};

const tomorrowCityStreet = {
  src: tomorrowCityStreet1280,
  srcSet: `${tomorrowCityStreet640} 640w, ${tomorrowCityStreet1280} 1280w, ${tomorrowCityStreet1920} 1920w`,
  width: 1920,
  height: 2880,
  alt: 'Adel Gomez walking along a city street with flowers for As Soon as Tomorrow'
};

export const bandLogo = {
  src: bandLogo640,
  srcSet: `${bandLogo320} 320w, ${bandLogo640} 640w, ${bandLogo1280} 1280w`,
  width: 1280,
  height: 988,
  alt: 'The Adel Gomez Band'
};

export const heroImage = studioElectricGuitar;
export const aboutImage = studioAcousticGuitar;

export const galleryImages = [
  studioElectricGuitar,
  studioAcousticGuitar,
  cityBeigeCoat,
  tomorrowStoneColumns,
  tomorrowStationBench,
  tomorrowStationStairs,
  tomorrowCityStreet
];
